import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/addModalTextLiteratureSlice";
import { FaRegCircleXmark } from "react-icons/fa6";
import { createDataTextLiterature, fetchDataTextLiterature, fetchDataLiterature } from "../../store/slices/apiLiteratureSlice";
import Select from "react-select";
import { toast } from "react-toastify";

const AddModalTextLiterature = ({
  title,
  submitButtonText,
  inputLabel2
}) => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.addModalTextLiterature.isOpen);

  const [selectedOption, setSelectedOption] = useState([]);
  const literature = useSelector((state) => state.apiLiterature.data);
  const [LiteratureTitle, setLiteratureTitle] = useState("");
  const [LiteratureText, setLiteratureText] = useState("");
  const [selectedPhoto, setSelectedPhoto] = useState(null);


  useEffect(() => {
    dispatch(fetchDataLiterature())
  },[]);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setSelectedPhoto(file);
  };

  const handleOpenModal = () => {
    dispatch(openModal());
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formData = new FormData();
    formData.append("title", LiteratureTitle);
    formData.append("text", LiteratureText);
    formData.append("literatureId", JSON.stringify(selectedOption));
    formData.append("photo", selectedPhoto);

    try {
      dispatch(createDataTextLiterature(formData));
      setLiteratureTitle("");
      setLiteratureText("");
      setSelectedPhoto(null);
      setSelectedOption(null);
      handleCloseModal();
      toast.success("Teksti u shtua me sukses!");
    } catch (error) {
      toast.error("Teksti nuk u shtua!");
      console.log("Error submitting data:", error);
    }
  };

  return (
    <div>
      <button
        className="text-white bg-orange-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-2.5 py-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
        data-modal-target="popup-modal"
        data-modal-toggle="popup-modal"
        onClick={handleOpenModal}
      >
        Shto Tekst
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center w-15">
          <div className="bg-gray-900 bg-opacity-40 absolute inset-0"></div>
          <div
            className="relative bg-white rounded-lg shadow-lg"
            style={{ width: "360px" }}
          >
            <button
              type="button"
              onClick={handleCloseModal}
              className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
            >
              <FaRegCircleXmark style={{ width: 20, height: 20 }} />
            </button>

            <div className="p-6 text-center">
              <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
                {title}
              </h3>
              <form className="space-y-6 text-start" onSubmit={handleSubmit}>
                <div>
                  <label
                    htmlFor="LiteratureTitle"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Titulli
                  </label>
                  <input
                    type="text"
                    name="LiteratureTitle"
                    id="LiteratureTitle"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Shkruaj emrin e literatures"
                    value={LiteratureTitle}
                    onChange={(e) => setLiteratureTitle(e.target.value)}
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="LiteratureText"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Tekst:
                  </label>
                  <textarea
                    name="LiteratureText"
                    id="LiteratureText"
                    className="h-40 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    placeholder="Shkruaj emrin e literatures"
                    value={LiteratureText}
                    onChange={(e) => setLiteratureText(e.target.value)}
                    required
                  />
                </div>
                {inputLabel2 && (
                  <div>
                    <label
                      htmlFor="input2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                    Zgjedh Literaturen
                    </label>
                    <Select
                      isMulti
                      isClearable
                      name="input2"
                      id="input2"
                      value={selectedOption}
                      onChange={handleOptionChange}
                      options={literature.map((option) => ({
                        value: option.id,
                        label: `${option.name} (Literatura: ${option.categoryName})`,
                      }))}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    />
                  </div>
                )}

                <div>
                  <label
                    htmlFor="photo"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Zgjedh ikonën:
                  </label>
                  <input
                    type="file"
                    name="photo"
                    id="photo"
                    accept=".png, .svg, .jpg"
                    onChange={handlePhotoChange}
                    required
                  />
                </div>
                
                <div className="flex justify-center">
                  <div className="flex items-center">
                    <button
                      type="submit"
                      className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 mr-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                    >
                      {submitButtonText}
                    </button>

                    <button
                      data-modal-hide="popup-modal"
                      type="button"
                      onClick={handleCloseModal}
                      className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                    >
                      Anulo
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddModalTextLiterature;
